import {
  CONTACT_US_LOADING,
  CONTACT_US_SUCCESS,
  CONTACT_US_FAILURE,
} from "redux/types";

const initialState = {
  contactUsLoading: false,
  contactUs: null,
  errors: null,
};

export const contactUsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CONTACT_US_LOADING:
      return { ...state, contactUsLoading: action.payload };
    case CONTACT_US_SUCCESS:
      return { ...state, contactUs: action.payload };
    case CONTACT_US_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
